import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

const Blog = () => {
  return (
    <section className="py-2 ">
      <Container>
        {/* -------- Section Header -------- */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Latest Updates</h2>
          <div
            style={{
              width: "60px",
              height: "3px",
              backgroundColor: "#F89A33",
              margin: "10px auto",
            }}
          ></div>
          <p className="text-muted mb-0">
            Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit
          </p>
        </div>

        <Row className="gx-5 gy-4 align-items-stretch">

          {/* LEFT COLUMN */}
          <Col md={6} className="d-flex">
            <div className="d-flex flex-column w-100 h-100">

              <h4 className="fw-bold text-dark mb-4">Latest Blogs</h4>

              <div className="d-flex flex-column flex-grow-1 gap-4">
                {[1, 2, 3].map((item, i) => (
                  <Card
                    key={i}
                    className="border-0 shadow-sm rounded-3 d-flex flex-fill"
                    style={{ minHeight: "140px" }}
                  >
                    <Row className="g-0 w-100 h-100">
                      <Col
                        md={4}
                        className="d-flex align-items-center justify-content-center bg-light"
                      >
                        <i className="bi bi-card-image text-secondary" style={{ fontSize: "3rem" }}></i>
                      </Col>

                      <Col md={8} className="d-flex">
                        <Card.Body className="d-flex flex-column justify-content-center">
                          <Card.Title className="fw-bold text-dark">
                            Blog Title {i + 1}
                          </Card.Title>
                          <small className="text-muted fw-semibold">
                            September 14, 2017
                          </small>
                          <Card.Text className="text-muted mt-2 mb-0">
                            Dummy content of printing and typesetting industry...
                          </Card.Text>
                        </Card.Body>
                      </Col>
                    </Row>
                  </Card>
                ))}
              </div>

              <div className="text-center mt-auto pt-3">
                <Button className="px-4 btn-grad border-0">VIEW ALL</Button>
              </div>

            </div>
          </Col>


          {/* RIGHT COLUMN */}
          <Col md={6} className="d-flex">
            <div className="d-flex flex-column w-100 h-100">

              <h4 className="fw-bold text-dark mb-4">Upcoming Courses</h4>

              <div className="d-flex flex-column flex-grow-1 gap-4">
                {[1, 2, 3].map((event, index) => (
                  <Card
                    key={index}
                    className="border-0 shadow-sm rounded-3 d-flex flex-fill"
                    style={{ minHeight: "140px" }}
                  >
                    <Row className="g-0 w-100 h-100">
                      <Col
                        md={3}
                        className="d-flex flex-column align-items-center justify-content-center blog-warning text-dark"
                      >
                        <h5 className="fw-bold mb-0">20</h5>
                        <small>Oct</small>
                        <div className="bg-dark text-white px-2 mt-1 rounded">
                          2026
                        </div>
                      </Col>

                      <Col md={9} className="d-flex">
                        <Card.Body className="d-flex flex-column justify-content-center">
                          <Card.Title className="fw-bold text-dark">
                            National Capital Leadership Conference
                          </Card.Title>
                          <Card.Text className="text-muted mb-1">
                            Dummy content of the printing industry...
                          </Card.Text>
                          <p className="fw-bold text-dark mb-0">
                            11:00 - 13:30
                          </p>
                        </Card.Body>
                      </Col>
                    </Row>
                  </Card>
                ))}
              </div>

              <div className="text-center mt-auto pt-3">
                <Button className="px-4 btn-grad border-0">VIEW ALL</Button>
              </div>

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default Blog;
